import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { FilterOption, RootState } from '../../Components/PriceSimulation/PriceSimulation.types';

const extractMonths = (identifier: string | null | undefined): number => {
    const match = identifier?.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
};

const useDynamicPlanOptions = (selectedPackages: FilterOption[]): FilterOption[] => {
    const packageDetailsMap = useSelector((state: RootState) => state.PriceSimulationReducer.packageDetailsMap);

    return useMemo(() => {
        if (selectedPackages.length === 0) return [];

        const planMap = new Map<string, FilterOption>();
        selectedPackages.forEach((pkg) => {
            const plans = packageDetailsMap[pkg.id]?.availablePlans;
            if (plans) {
                plans.forEach((plan) => {
                    const identifier = plan.identifier;
                    if (typeof identifier === 'string' && identifier !== '') {
                        planMap.set(identifier, { id: identifier, name: plan.name });
                    }
                });
            }
        });

        return Array.from(planMap.values()).sort((a, b) => extractMonths(String(a.id)) - extractMonths(String(b.id)));
    }, [selectedPackages, packageDetailsMap]);
};

export default useDynamicPlanOptions;
